<template>
  <div id="content" v-html="html"></div>
</template>

<script>
import PrivacytHmtl from './privacy';

export default {
  name: 'Privacy',
  data() {
    return {
      html: PrivacytHmtl,
    };
  },
};
</script>

<style scoped>
#content {
  width: 100%;
  box-sizing: border-box;
  padding: 15px;
}
#content >>> p {
  text-align: left !important;
}

#content >>> li,
#content >>> ul {
  text-align: left !important;
}
</style>
